"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupSizeBreakdown = void 0;
const getGroupSizeBreakdown = (number_of_golfers, max_group_size) => {
    if (!number_of_golfers)
        return [];
    if (!max_group_size)
        return [];
    if (number_of_golfers <= max_group_size)
        return [number_of_golfers];
    if (max_group_size === 4) {
        // eveny distribute the number_of_golfers into groups where the max_group_size is 4 for up to 64 number_of_golfers
        if (number_of_golfers === 5)
            return [3, 2];
        if (number_of_golfers === 6)
            return [3, 3];
        if (number_of_golfers === 7)
            return [4, 3];
        if (number_of_golfers === 8)
            return [4, 4];
        if (number_of_golfers === 9)
            return [3, 3, 3];
        if (number_of_golfers === 10)
            return [4, 3, 3];
        if (number_of_golfers === 11)
            return [4, 4, 3];
        if (number_of_golfers === 12)
            return [4, 4, 4];
        if (number_of_golfers === 13)
            return [4, 3, 3, 3];
        if (number_of_golfers === 14)
            return [4, 4, 3, 3];
        if (number_of_golfers === 15)
            return [4, 4, 4, 3];
        if (number_of_golfers === 16)
            return [4, 4, 4, 4];
        if (number_of_golfers === 17)
            return [4, 4, 3, 3, 3];
        if (number_of_golfers === 18)
            return [4, 4, 4, 3, 3];
        if (number_of_golfers === 19)
            return [4, 4, 4, 4, 3];
        if (number_of_golfers === 20)
            return [4, 4, 4, 4, 4];
        if (number_of_golfers === 21)
            return [4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 22)
            return [4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 23)
            return [4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 24)
            return [4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 25)
            return [4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 26)
            return [4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 27)
            return [4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 28)
            return [4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 29)
            return [4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 30)
            return [4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 31)
            return [4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 32)
            return [4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 33)
            return [4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 34)
            return [4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 35)
            return [4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 36)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 37)
            return [4, 4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 38)
            return [4, 4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 39)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 40)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 41)
            return [4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 42)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 43)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 44)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 45)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 46)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 47)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 48)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 49)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 50)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 51)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 52)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 53)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 54)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 55)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 56)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 57)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 58)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 59)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 60)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
        if (number_of_golfers === 61)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3, 3];
        if (number_of_golfers === 62)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3, 3];
        if (number_of_golfers === 63)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 3];
        if (number_of_golfers === 64)
            return [4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];
    }
    if (max_group_size === 5) {
        // eveny distribute the number_of_golfers into groups where the max_group_size is 5 for up to 64 number_of_golfers in the smallest number of groups
        if (number_of_golfers === 6)
            return [3, 3];
        if (number_of_golfers === 7)
            return [4, 3];
        if (number_of_golfers === 8)
            return [4, 4];
        if (number_of_golfers === 9)
            return [5, 4];
        if (number_of_golfers === 10)
            return [5, 5];
        if (number_of_golfers === 11)
            return [4, 4, 3];
        if (number_of_golfers === 12)
            return [4, 4, 4];
        if (number_of_golfers === 13)
            return [5, 4, 4];
        if (number_of_golfers === 14)
            return [5, 5, 4];
        if (number_of_golfers === 15)
            return [5, 5, 5];
        if (number_of_golfers === 16)
            return [4, 4, 4, 4];
        if (number_of_golfers === 17)
            return [5, 4, 4, 4];
        if (number_of_golfers === 18)
            return [5, 5, 4, 4];
        if (number_of_golfers === 19)
            return [5, 5, 5, 4];
        if (number_of_golfers === 20)
            return [5, 5, 5, 5];
        if (number_of_golfers === 21)
            return [5, 4, 4, 4, 4];
        if (number_of_golfers === 22)
            return [5, 5, 4, 4, 4];
        if (number_of_golfers === 23)
            return [5, 5, 5, 4, 4];
        if (number_of_golfers === 24)
            return [5, 5, 5, 5, 4];
        if (number_of_golfers === 25)
            return [5, 5, 5, 5, 5];
        if (number_of_golfers === 26)
            return [5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 27)
            return [5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 28)
            return [5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 29)
            return [5, 5, 5, 5, 5, 4];
        if (number_of_golfers === 30)
            return [5, 5, 5, 5, 5, 5];
        if (number_of_golfers === 31)
            return [5, 5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 32)
            return [5, 5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 33)
            return [5, 5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 34)
            return [5, 5, 5, 5, 5, 5, 4];
        if (number_of_golfers === 35)
            return [5, 5, 5, 5, 5, 5, 5];
        if (number_of_golfers === 36)
            return [5, 5, 5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 37)
            return [5, 5, 5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 38)
            return [5, 5, 5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 39)
            return [5, 5, 5, 5, 5, 5, 5, 4];
        if (number_of_golfers === 40)
            return [5, 5, 5, 5, 5, 5, 5, 5];
        if (number_of_golfers === 41)
            return [5, 5, 5, 5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 42)
            return [5, 5, 5, 5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 43)
            return [5, 5, 5, 5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 44)
            return [5, 5, 5, 5, 5, 5, 5, 5, 4];
        if (number_of_golfers === 45)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5];
        if (number_of_golfers === 46)
            return [5, 5, 5, 5, 5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 47)
            return [5, 5, 5, 5, 5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 48)
            return [5, 5, 5, 5, 5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 49)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 4];
        if (number_of_golfers === 50)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
        if (number_of_golfers === 51)
            return [5, 5, 5, 5, 5, 5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 52)
            return [5, 5, 5, 5, 5, 5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 53)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 54)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 4];
        if (number_of_golfers === 55)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
        if (number_of_golfers === 56)
            return [5, 5, 5, 5, 5, 5, 5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 57)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 58)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 59)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 4];
        if (number_of_golfers === 60)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
        if (number_of_golfers === 61)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 4, 4, 4, 4];
        if (number_of_golfers === 62)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 4, 4, 4];
        if (number_of_golfers === 63)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 4, 4];
        if (number_of_golfers === 64)
            return [5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 4];
    }
    if (max_group_size === 6) {
        // evenly distribute the number_of_golfers into groups where the max_group_size is 6 for up to 64 number_of_golfers in the smallest number of groups
        if (number_of_golfers === 7)
            return [4, 3];
        if (number_of_golfers === 8)
            return [4, 4];
        if (number_of_golfers === 9)
            return [5, 4];
        if (number_of_golfers === 10)
            return [5, 5];
        if (number_of_golfers === 11)
            return [6, 5];
        if (number_of_golfers === 12)
            return [6, 6];
        if (number_of_golfers === 13)
            return [5, 4, 4];
        if (number_of_golfers === 14)
            return [5, 5, 4];
        if (number_of_golfers === 15)
            return [5, 5, 5];
        if (number_of_golfers === 16)
            return [6, 5, 5];
        if (number_of_golfers === 17)
            return [6, 6, 5];
        if (number_of_golfers === 18)
            return [6, 6, 6];
        if (number_of_golfers === 19)
            return [5, 5, 5, 4];
        if (number_of_golfers === 20)
            return [5, 5, 5, 5];
        if (number_of_golfers === 21)
            return [6, 5, 5, 5];
        if (number_of_golfers === 22)
            return [6, 6, 5, 5];
        if (number_of_golfers === 23)
            return [6, 6, 6, 5];
        if (number_of_golfers === 24)
            return [6, 6, 6, 6];
        if (number_of_golfers === 25)
            return [5, 5, 5, 5, 5];
        if (number_of_golfers === 26)
            return [6, 5, 5, 5, 5];
        if (number_of_golfers === 27)
            return [6, 6, 5, 5, 5];
        if (number_of_golfers === 28)
            return [6, 6, 6, 5, 5];
        if (number_of_golfers === 29)
            return [6, 6, 6, 6, 5];
        if (number_of_golfers === 30)
            return [6, 6, 6, 6, 6];
        if (number_of_golfers === 31)
            return [6, 5, 5, 5, 5, 5];
        if (number_of_golfers === 32)
            return [6, 6, 5, 5, 5, 5];
        if (number_of_golfers === 33)
            return [6, 6, 6, 5, 5, 5];
        if (number_of_golfers === 34)
            return [6, 6, 6, 6, 5, 5];
        if (number_of_golfers === 35)
            return [6, 6, 6, 6, 6, 5];
        if (number_of_golfers === 36)
            return [6, 6, 6, 6, 6, 6];
        if (number_of_golfers === 37)
            return [6, 6, 5, 5, 5, 5, 5];
        if (number_of_golfers === 38)
            return [6, 6, 6, 5, 5, 5, 5];
        if (number_of_golfers === 39)
            return [6, 6, 6, 6, 5, 5, 5];
        if (number_of_golfers === 40)
            return [6, 6, 6, 6, 6, 5, 5];
        if (number_of_golfers === 41)
            return [6, 6, 6, 6, 6, 6, 5];
        if (number_of_golfers === 42)
            return [6, 6, 6, 6, 6, 6, 6];
        if (number_of_golfers === 43)
            return [6, 6, 6, 5, 5, 5, 5, 5];
        if (number_of_golfers === 44)
            return [6, 6, 6, 6, 5, 5, 5, 5];
        if (number_of_golfers === 45)
            return [6, 6, 6, 6, 6, 5, 5, 5];
        if (number_of_golfers === 46)
            return [6, 6, 6, 6, 6, 6, 5, 5];
        if (number_of_golfers === 47)
            return [6, 6, 6, 6, 6, 6, 6, 5];
        if (number_of_golfers === 48)
            return [6, 6, 6, 6, 6, 6, 6, 6];
        if (number_of_golfers === 49)
            return [6, 6, 6, 6, 5, 5, 5, 5, 5];
        if (number_of_golfers === 50)
            return [6, 6, 6, 6, 6, 5, 5, 5, 5];
        if (number_of_golfers === 51)
            return [6, 6, 6, 6, 6, 6, 5, 5, 5];
        if (number_of_golfers === 52)
            return [6, 6, 6, 6, 6, 6, 6, 5, 5];
        if (number_of_golfers === 53)
            return [6, 6, 6, 6, 6, 6, 6, 6, 5];
        if (number_of_golfers === 54)
            return [6, 6, 6, 6, 6, 6, 6, 6, 6];
        if (number_of_golfers === 55)
            return [6, 6, 6, 6, 6, 5, 5, 5, 5, 5];
        if (number_of_golfers === 56)
            return [6, 6, 6, 6, 6, 6, 5, 5, 5, 5];
        if (number_of_golfers === 57)
            return [6, 6, 6, 6, 6, 6, 6, 5, 5, 5];
        if (number_of_golfers === 58)
            return [6, 6, 6, 6, 6, 6, 6, 6, 5, 5];
        if (number_of_golfers === 59)
            return [6, 6, 6, 6, 6, 6, 6, 6, 6, 5];
        if (number_of_golfers === 60)
            return [6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
        if (number_of_golfers === 61)
            return [6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5];
        if (number_of_golfers === 62)
            return [6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5];
        if (number_of_golfers === 63)
            return [6, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5];
        if (number_of_golfers === 64)
            return [6, 6, 6, 6, 6, 6, 6, 6, 6, 5, 5];
    }
};
exports.getGroupSizeBreakdown = getGroupSizeBreakdown;
